<template>
  <div class="product-page">
    <!-- <div class="header-wrap app-flex-mid-center">
      <div class="left-wrap">
        <div class="title">固定式螺杆空气压缩机</div>
        <div class="sign"></div>
        <div class="desc">寿力固定式螺杆空气压缩机，为您提供可靠、耐用、高性能的压缩空气。</div>
      </div>
      <div class="right-wrap">
        <img src="../../../assets/area/pro1.png" class="pro-1" />
      </div>
    </div> -->

    <div class="main">
      <base-title title="工业产品" rich-title="industrial product" class="margin-top-zero"></base-title>
      <div class="block-box">
        <div class="header-title">1.离心式空压机、螺杆式空压机</div>
        <div class="image-wrap app-flex-mid-center">
          <img src="../../../assets/area/pro2.png" class="desc-image" />
        </div>
        <p class="desc-text">
          我司经营美国寿力离心式空压机、螺杆式空压机、螺杆式真空泵，广泛运用于电子、火电、化工、新能源、汽车、纺织、医药等多个行业。我司致力于为各行各业的客户提供全面、稳定、优良的压缩空气解决方案及高效、高质的售后服务。</p>
      </div>

      <div class="block-box">
        <div class="header-title">2.制氮机、制氧机</div>
        <div class="image-wrap app-flex-mid-center">
          <img src="../../../assets/area/pro6.png" class="desc-image" />
        </div>
        <div class="image-wrap app-flex-mid-center" style="margin-top:20px;">
          <img src="../../../assets/area/pro7.png" class="desc-image" />
        </div>
        <div class="image-wrap app-flex-mid-center">
          <img src="../../../assets/area/pro8.png" class="desc-image" />
        </div>
        <p class="desc-text">
          我司经营西梅卡变压吸附制氮机和制氧机、氮气净化系统、气体增压系统，广泛运用于电子、火电、化工、新能源、汽车、纺织、医药等多个行业。我司致力于为各行各业的客户提供更加广泛和完善的空分系统解决方案。</p>
      </div>

      <!-- <div class="pro-list">
        <div class="pro-item" v-for="item in proList" :key="item.id">
          <div class="image-wrap app-flex-mid-center">
            <img :src="require('../../../assets/area/1-' + item.id + '.png')" class="pro-img" />
          </div>
          <p class="pro-item-desc">{{ item.name }}</p>
        </div>
      </div> -->

      <div class="block-box">
        <div class="header-title">3.压缩空气后处理设备</div>
        <div class="image-wrap app-flex-mid-center">
          <img src="../../../assets/area/pro9.png" class="desc-image" />
        </div>
        <div class="image-wrap app-flex-mid-center">
          <img src="../../../assets/area/pro10.png" class="desc-image" />
        </div>
        <div class="image-wrap app-flex-mid-center">
          <img src="../../../assets/area/pro11.png" class="desc-image" />
        </div>
        <p class="desc-text">
          我司经营纽曼泰克全系列吸干机、冷干机及管道过滤器。广泛运用于电子、火电、化工、新能源、汽车、纺织、医药等多个行业。我司致力于为各行各业的客户提供更加广泛和完善的气体净化处理系统解决方案。</p>
      </div>

      <div class="block-box">
        <div class="header-title">4.工业阀门（含调阀）</div>
        <div class="image-wrap app-flex-mid-center">
          <img src="../../../assets/area/pro12.png" class="desc-image" />
        </div>
        <div class="image-wrap app-flex-mid-center">
          <img src="../../../assets/area/pro13.png" class="desc-image" />
        </div>
        <p class="desc-text">
          我司专业经营中高端阀门及其配套产品，目前经营美国泰科阀门、日本中北阀门（NAKAKITA）、德国西门子、美国费希尔等品牌，并能提供整套流体系统解决方案，包括流体系统设计、流体系统的节能咨询、流体系统产品成套设备安装、现场售后服务及系统维护服务。
        </p>
      </div>

      <div class="block-box">
        <div class="header-title">5.工业滤芯</div>
        <div class="image-wrap app-flex-mid-center">
          <img src="../../../assets/area/pro14.png" class="desc-image" />
        </div>
        <p class="desc-text">我司专业经营水气过滤滤芯、天然气过滤滤芯、润滑油系统过滤滤芯，目前经营普瑞奇、德国贺德克、德国科德宝、美国唐纳森、美国颇尔等品牌。</p>
      </div>
    </div>

    <base-foot></base-foot>
  </div>
</template>

<script>
import BaseFoot from '../components/BaseFoot.vue'
import BaseTitle from '../components/BaseTitle.vue'

export default {
  name: 'ProductPage',
  components: {
    BaseFoot,
    BaseTitle
  },
  data() {
    return {
      proList: [
        {
          id: 1,
          name: '变压吸附制氧'
        },
        {
          id: 2,
          name: '非空气分离膜'
        },
        {
          id: 3,
          name: '氮气纯化系统'
        },
        {
          id: 4,
          name: '膜制氮系统'
        },
        {
          id: 5,
          name: '真空变压吸附制氧'
        },
        {
          id: 6,
          name: '变压吸附制氮'
        },
        {
          id: 7,
          name: '气体增压系统'
        },
        {
          id: 8,
          name: '现场制氮设备租赁及技术服务'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.product-page {
  width: 100%;
  background: linear-gradient(180deg, #d3e5f7 0%, #ffffff 3%);

  .header-wrap {
    width: 100%;
    padding: 133px 0px;

    .left-wrap {
      .title {
        font-size: 54px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 95px;
      }

      .sign {
        width: 50px;
        height: 10px;
        margin: 6px 0px 37px;
        background-color: #eb543c;
      }

      .desc {
        max-width: 670px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #63676a;
        line-height: 46px;
      }
    }

    .right-wrap {
      margin-left: 89px;

      .pro-1 {
        height: 462px;
        width: auto;
      }
    }
  }

  .main {
    padding: 100px 240px 178px;

    .block-box {
      margin-top: 100px;

      .header-title {
        margin-bottom: 10px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 43px;
      }

      .image-wrap {
        width: 100%;

        .desc-image {
          width: 100%;
          height: auto;
        }
      }

      .desc-text {
        margin-top: 24px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 43px;
        text-indent: 52px;
        word-break: break-all;
      }
    }

    .pro-list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 100px;

      .pro-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        &:not(:nth-child(4n)) {
          margin-right: 40px;
        }

        &:nth-child(-n + 4) {
          margin-bottom: 35px;
        }

        .image-wrap {
          width: 320px;
          height: 320px;
          overflow: hidden;
          transition: all 0.3s;

          &:hover {
            transform: scale(1.01);
            box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.2);
          }

          .pro-img {
            width: 320px;
            height: auto;
          }
        }

        .pro-item-desc {
          padding: 24px 0px;
          max-width: 210px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 37px;
          text-align: center;
        }
      }
    }
  }
}

.margin-top-zero {
  margin-top: 0px;
}
</style>
